<template>
  <div>
    <Header :right-sidebar="true" right-sidebar-title="Профсоюзы">
      <template #right-sidebar>
        <sidebar-items-group title="Отображать столбцы">
          <fields-picker
            v-model="pickedFields"
            :fields="displayableProfessionalGroupsFields"
          />
        </sidebar-items-group>
        <sidebar-items-group title="Фильтры">
          <filters-group
            :fields="professionalGroupsFields"
            :items="professionalGroups"
            v-model="filteredItems"
          />
        </sidebar-items-group>
        <sidebar-item
          variant="success"
          :to="`/unions/${unionId}/professional-groups/create`"
        >
          Добавить профгруппу
          <template #icon>
            <b-icon icon="plus-square" />
          </template>
        </sidebar-item>
      </template>
    </Header>
    <h1 class="special-title">
      {{ unionName }}
    </h1>
    <Main>
      <b-table
        selectable
        select-mode="single"
        :busy="!loaded"
        :responsive="true"
        :items="paintedRows"
        :fields="pickedFields"
        @row-clicked="item => openProfessionalGroup(item)"
        hover
        class="table-rounded"
        empty-text="Записей нет"
      />
    </Main>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import SidebarItemsGroup from "@/components/Layout/Sidebars/SidebarItems/SidebarItemsGroup";
import FieldsPicker from "@/components/Tables/FieldsPicker";
import FiltersGroup from "@/components/Tables/Filters/FiltersGroup";
import SidebarItem from "@/components/Layout/Sidebars/SidebarItems/SidebarItem";
import Main from "@/components/Layout/Main";
import { displayableFields } from "@/components/Tables/defaultFields";
import { defaultRowPainter } from "@/components/Tables/rowPainters";
import axios from "@/axios";
import { professionalGroupsFields } from "@/views/Unions/ProfessionalGroups/models/professionalGroupsFields";
import { mapGetters } from "vuex";
import pageTitleMixin from "@/mixins/pageTitleMixin";

export default {
  components: {
    Main,
    SidebarItem,
    FiltersGroup,
    FieldsPicker,
    SidebarItemsGroup,
    Header
  },
  mixins: [pageTitleMixin],
  props: {
    unionId: {
      type: Number,
      required: true
    }
  },
  data() {
    let displayableProfessionalGroupsFields = displayableFields(
      professionalGroupsFields
    );
    return {
      professionalGroupsFields,
      displayableProfessionalGroupsFields,
      professionalGroups: [],
      loaded: false,
      filteredItems: [],
      pickedFields: displayableProfessionalGroupsFields
    };
  },
  computed: {
    ...mapGetters("unions", ["unions"]),
    union: ({ unions, unionId }) =>
      unions.find(({ id }) => Number(id) === unionId),
    unionName: ({ union }) => (union !== undefined ? union.name : ""),
    paintedRows: ({ filteredItems }) => defaultRowPainter(filteredItems)
  },
  methods: {
    openProfessionalGroup({ id }) {
      this.$router.push(`/unions/${this.unionId}/professional-groups/${id}`);
    }
  },
  async created() {
    this.professionalGroups = (
      await axios.get(`/unions/${this.unionId}/professional-groups`)
    ).data.unions_professional_groups;
    this.loaded = true;
  }
};
</script>
